export type ApplicationAttachmentInitialValue = Omit<ApplicationAttachment, 'id' | 'createdDate'>;

export interface ApplicationAttachment<Type extends ApplicationAttachmentType = ApplicationAttachmentType> {
  id: string;
  type: Type;
  filename: string;
  path: string;
  mediaType: ApplicationAttachmentMediaType;
  context: ApplicationAttachmentTypeContexts[Type];
  createdDate: string;
}

export enum ApplicationAttachmentType {
  DashDriverReport = 'dashDriverReport',
}

export type ApplicationAttachmentMediaType = 'application/pdf';

export type ApplicationAttachmentTypeContexts = {
  [ApplicationAttachmentType.DashDriverReport]: ApplicationAttachmentDashDriverReportContext;
};

export interface ApplicationAttachmentDashDriverReportContext {
  driverId: string;
  yearsOfData: number;
  numberOfClaimsLast6Years: number;
}
